exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-icon-v2.disabled{cursor:not-allowed}.cap-icon-v2-avatar{margin-right:.571rem;display:flex;align-items:center;position:relative;height:2.285rem;width:2.285rem}.cap-icon-v2-avatar .text-label{position:absolute;right:50%;top:50%;transform:translate(50%, -50%);line-height:14px;font-size:16px;font-weight:500}\n", ""]);

// exports
